import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // Importe o estilo CSS do editor

const RichTextEditor = (props) => {
    // Configuração das opções da toolbar
    const toolbarOptions = [
        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        ['blockquote', 'code-block'],

        [{ 'header': 1 }, { 'header': 2 }],               // custom button values
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
        [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
        [{ 'direction': 'rtl' }],                         // text direction

        [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

        [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
        [{ 'font': [] }],
        [{ 'align': [] }],

        ['image'],  // Inserir imagem

        ['clean'],                                         // remove formatting button
    ];

    // Handler para atualizar o conteúdo do editor
    const handleTextChange = (value) => {
        props?.setText(value)
    };

    // Função para obter o tamanho em bytes do texto personalizado salvo
    const getCustomTextSizeInBytes = () => {
        return new Blob([props?.text]).size;
    };

    // Função para converter o tamanho de bytes para KB ou MB
    const formatSize = (bytes) => {
        const kb = bytes / 1024;
        const mb = kb / 1024;
        return mb > 1 ? mb.toFixed(2) + ' MB' : kb.toFixed(2) + ' KB';
    };

    return (
        <div className='bg-white-100 mt-[4.5rem]'>
            <div className={`overflow-y-scroll min-h-[15rem] ${props?.isFullScreen ? 'max-h-[84vh]' : 'max-h-[15rem]'} `}>
                <ReactQuill
                    theme="snow"
                    value={props?.text}
                    onChange={handleTextChange}
                    modules={{ toolbar: toolbarOptions }}
                />
            </div>

            <p className='text-[0.7rem] text-gray-500'>Tamanho do conteúdo: {formatSize(getCustomTextSizeInBytes())}</p>
        </div>
    );
};

export default RichTextEditor;
